import { EventReceiver } from "../busWorker/EventReceiver";
class BusWorkerSenderMessagePortPolyfill {
    // eslint-disable-next-line accessor-pairs
    set onmessage(_callback) {
        throw new Error("onmessage on SenderMessagePortPolyfill is not supported");
    }
    constructor(worker) {
        this.worker = worker;
        this.onmessageerror = null;
        this.onErrorEvent = (ev) => {
            if (this.onmessageerror === undefined || this.onmessageerror === null)
                return;
            this.onmessageerror(ev);
        };
        worker.addEventListener("error", this.onErrorEvent);
    }
    start() { }
    close() {
        this.worker.removeEventListener("error", this.onErrorEvent);
        this.worker.terminate();
    }
    postMessage(message, param) {
        this.worker.postMessage(message, param);
    }
    addEventListener() {
        throw new Error("addEventListener on port not supported");
    }
    removeEventListener() {
        throw new Error("removeEventListener on port not supported");
    }
    dispatchEvent() {
        return true;
    }
}
export class BusWorkerReceiverMessagePortPolyfill {
    constructor(worker) {
        this.worker = worker;
        this.mainPort = new MainWorkerMessagePortPolyfill();
        this.receiver = new EventReceiver(this.mainPort);
        this.onmessage = null;
        this.onmessageerror = null;
        this.mainPort.onmessage = (ev) => {
            if (this.onmessage === undefined || this.onmessage === null)
                return;
            this.onmessage(ev);
        };
    }
    start() { }
    close() {
        this.mainPort.onmessage = null;
        this.worker.terminate();
    }
    postMessage(message) {
        this.receiver.handleMessage(message);
    }
    addEventListener() {
        throw new Error("addEventListener on port not supported");
    }
    removeEventListener() {
        throw new Error("removeEventListener on port not supported");
    }
    dispatchEvent() {
        return true;
    }
}
class MainWorkerMessagePortPolyfill {
    constructor() {
        this.onmessage = null;
        this.onmessageerror = null;
    }
    start() { }
    close() { }
    postMessage(message) {
        if (this.onmessage === undefined || this.onmessage === null)
            throw new Error("onmessage is not defined");
        this.onmessage(new MessageEvent("message", { data: message }));
    }
    addEventListener() {
        throw new Error("addEventListener on port not supported");
    }
    removeEventListener() {
        throw new Error("removeEventListener on port not supported");
    }
    dispatchEvent() {
        return true;
    }
}
export class SharedWorkerPolyfill {
    constructor() {
        this.onerror = null;
        this.onmessage = null;
        this.port = new BusWorkerReceiverMessagePortPolyfill(this);
        this.workers = new Set();
    }
    terminate() {
        for (const worker of this.workers) {
            worker.terminate();
        }
    }
    register(worker) {
        if (this.workers.has(worker)) {
            throw new Error("Worker already registered");
        }
        this.workers.add(worker);
        const receiver = new EventReceiver(new BusWorkerSenderMessagePortPolyfill(worker));
        worker.addEventListener("message", (msg) => {
            receiver.receiveEvent(msg);
        });
    }
}
